export enum RangeYearsOption {
  Zero = '0',
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
  Seven = '7',
  Eight = '8',
  Nine = '9',
  Ten = '10',
  Eleven = '11',
  Twelve = '12',
  Thirteen = '13',
  Fourteen = '14',
  Fifteen = '15',
  Sixteen = '16',
  Seventeen = '17',
  Eighteen = '18',
  Nineteen = '19',
  Twenty = '20',
  TwentyFive = '25',
  Thirty = '30',
  ThirtyFive = '35',
  Forty = '40',
  FortyFive = '45',
  Fifty = '50',
  SeventyFive = '75',
  OneHundred = '100'
};

export const RANGE_YEARS_OPTIONS_ARRAY = Object.values(RangeYearsOption);

export const MAX_FREE_RANGE_YEARS_OPTION = RangeYearsOption.Five;
export const MAX_BASIC_RANGE_YEARS_OPTION = RangeYearsOption.Forty;
export const MAX_EXTRA_RANGE_YEARS_OPTION = RangeYearsOption.Forty;

const MAX_FREE_OPTION_INDEX = RANGE_YEARS_OPTIONS_ARRAY.indexOf(MAX_FREE_RANGE_YEARS_OPTION);
const MAX_BASIC_OPTION_INDEX = RANGE_YEARS_OPTIONS_ARRAY.indexOf(MAX_BASIC_RANGE_YEARS_OPTION);
const MAX_EXTRA_OPTION_INDEX = RANGE_YEARS_OPTIONS_ARRAY.indexOf(MAX_EXTRA_RANGE_YEARS_OPTION);

export function isRangeYearsOptionAllowedForFreeUsers(option: RangeYearsOption) {
  const rangeYearsOptionsArrayIndex = RANGE_YEARS_OPTIONS_ARRAY.indexOf(option);

  return rangeYearsOptionsArrayIndex >= 0 && rangeYearsOptionsArrayIndex <= MAX_FREE_OPTION_INDEX;
}

export function isRangeYearsOptionAllowedForBasicMembers(option: RangeYearsOption) {
  const rangeYearsOptionsArrayIndex = RANGE_YEARS_OPTIONS_ARRAY.indexOf(option);

  return rangeYearsOptionsArrayIndex >= 0 && rangeYearsOptionsArrayIndex <= MAX_BASIC_OPTION_INDEX;
}

export function isRangeYearsOptionAllowedForExtraMembers(option: RangeYearsOption) {
  const rangeYearsOptionsArrayIndex = RANGE_YEARS_OPTIONS_ARRAY.indexOf(option);

  return rangeYearsOptionsArrayIndex >= 0 && rangeYearsOptionsArrayIndex <= MAX_EXTRA_OPTION_INDEX;
}
